import Svg from 'UI/components/Svg';
import cn from 'classnames';
import LinkWrapper from 'components/Common/LinkWrapper';
import styles from './styles.module.scss';
import { NavItem } from '../NavItem';
import { CLIENTS_LIST, NAVIGATION, YELLOW_NUMBERS } from '../../utils/headerConstants';

const CompanyMenu = ({ isLightTheme, isPageScrolledDown }) => (
  <div className={cn(styles.dropdownContainer, { [styles.light]: isLightTheme || isPageScrolledDown })}>
    <div className={styles.contentContainer}>
      <div className={styles.leftContent}>
        <p className={styles.serviceTitle}>
          Measurable success powered by
          <br />
          AI innovation
        </p>
        <p>Our Clients</p>
        <div className={styles.clientsList}>
          {CLIENTS_LIST.map(({ icon, path, title }) => (
            <LinkWrapper
              path={path}
              className={styles.clientImage}
            >
              <div className={styles.clientContainer}>
                <div className={styles.clientIconContainer}>
                  <Svg type={icon} />
                </div>
                <p>{title}</p>
              </div>
            </LinkWrapper>
          ))}
        </div>
      </div>
    </div>
    <div className={styles.ourWorkContent}>
      <div>
        <p>
          Yellow in Numbers
        </p>
        <div className={styles.yellowNumbers}>
          {YELLOW_NUMBERS.map(({ title, description }) => (
            <div>
              <p>{title}</p>
              <span>{description}</span>
            </div>
          ))}
        </div>
      </div>
      <div>
        <p>Navigation</p>
        <div>
          {NAVIGATION.map(({ title, description, path }) => (
            <NavItem
              title={title}
              description={description}
              path={path}
            />
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default CompanyMenu;
